import Swiper from 'swiper';

let menuComplexSlider = new Swiper(".menu-complex", {
    slidesPerView: 'auto',
    spaceBetween: 10,
    loop: false,
    allowTouchMove: true,
    breakpoints: {
        1171: {
            allowTouchMove: false,
        }
    },
});

if(document.body.clientWidth <= 1170) {
    let width = 0;
    document.querySelectorAll('.menu-complex .menu-complex__item').forEach((item) => {
        if (!item.classList.contains('active')) {
            width = width + item.offsetWidth + 10;
        }
        else {
            width = width - document.body.clientWidth / 2 + item.offsetWidth / 2 + 10;
            if(width > 0) {
                menuComplexSlider.setTranslate(-width);
            }
        }
    });
}